import Link from 'next/link';
import { uaParse } from '@/intl-jdi-common-ssr/utils/uaParser';
import pageSDK from '@/utils/goToPage';

const JumpType = {
  Code: 'page-code',
  Url: 'custom',
};

interface JumpParams {
  jumpId?: null | string;
  jumpType: string;
  jumpDev?: null | string;
  jumpValue: any;
}

const getSkuIdFromUrl = (url: string): string | undefined => {
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    if (pathname.startsWith('/dp/')) {
      return pathname.match(/\/(\d+)$/)?.[1];
    }
  } catch (error) {}
};

export default function JumpLink(props: {
  jumpParams: JumpParams;
  children?: React.ReactNode;
  className?: string;
}) {
  const jumpType = props.jumpParams?.jumpType;
  const jumpValue = props.jumpParams?.jumpValue;
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (jumpType === JumpType.Code) {
      return;
    } else if (jumpType === JumpType.Url) {
      e.preventDefault();
      e.stopPropagation();
      if (uaParse().isInJoybuyApp) {
        const skuId = getSkuIdFromUrl(jumpValue.link);
        if (skuId) {
          // 如果在joybuyApp里跳商详页，则直接唤起原生商详页
          return pageSDK.goToProduct({ skuId });
        } else {
          window.location.href = jumpValue.link;
        }
      }
      window.location.href = jumpValue.link;
    }
  };

  let href = '#';
  // -------------- JumpType: Code -------------------- //
  if (jumpType === JumpType.Code) {
    // ochama app里打开落地页后，可能会直接唤起joybuy app，落地页在app里打开是需要加hideTitle=true的参数的，否则会出现双头问题
    // href = `/cms/${jumpValue.pageCodeInfo?.pageCode}?hideTitle=true`;
    // 加上hideTitle=true参数后，ochama app里唤起joybuy app无法跳转到对应的webview，所以暂时恢复代码
    // 在joybuyApp里要加上hideTitle=true参数，这样才能进入下一个页面的时候，展示出h5的头
    href = `/cms/${jumpValue.pageCodeInfo?.pageCode}${uaParse().isInJoybuyApp ? '?hideTitle=true' : ''}`;
  }
  // -------------- JumpType: Url -------------------- //
  if (jumpType === JumpType.Url) {
    href = jumpValue.link;
  }
  // avoid href to be #
  return (
    <Link href={href} onClick={handleClick} className={props.className}>
      {props.children}
    </Link>
  );
}
